import * as types from '../types.js';
import obs_load_warehouses_create_outputs from '../types/obs_load_warehouses_create_outputs.js';

export default {

	html: `
		<style>
			#create-outputs.form {
				width: min(32rem, calc(100vw - 1.5rem));
				max-width: 32rem;
				box-sizing: border-box;
				overflow-x: hidden;
			}
			#create-outputs .title { word-break: break-word; }
			#create-outputs #co-wh-hint {
				margin: 0.35rem 0 0.75rem;
				font-size: 0.85rem;
				line-height: 1.35;
				color: #444;
				max-width: 100%;
			}
			#create-outputs .co-field {
				display: block;
				width: 100%;
				max-width: 100%;
				box-sizing: border-box;
				margin-right: 0;
			}
			#create-outputs #company_id,
			#create-outputs #warehouse_id {
				width: 100%;
				max-width: 100%;
				box-sizing: border-box;
			}
			#create-outputs .ckb {
				display: flex;
				flex-wrap: wrap;
				gap: 0.75rem 1.25rem;
				align-items: center;
			}
			#create-outputs .ckb label { margin-bottom: 0; margin-right: 0; }
		</style>
		<form id="create-outputs" class="form sial-create-outputs-form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<div class="title" id="co-wh-title">
				Armazém físico
			</div>
			<p id="co-wh-hint" class="hint"></p>
			<div class="mtl fsb">
				<label class="co-field" title="Empresa">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
			</div>
			<div class="fsb">
				<label class="co-field" title="Somente armazéns físicos ativos; obrigatório se houver mais de um" id="co-wh-label">Armazém físico (lista)
					<select id="warehouse_id" disabled>
						<option value="">— Escolha a empresa primeiro —</option>
					</select>
				</label>
			</div>
			<div class="ckb">
				<label title="Incluir itens com validade vencida na busca?">
					<input id="include_expired" type="checkbox" class="dib">&nbsp;Incluir expirados
				</label>
				<label title="Reservar estoques ou apenas estimar percentuais de atendimento?">
					Reservar estoques <input id="reserve_flag" type="checkbox" class="dib">
				</label>
				<label title="Gerar saída para esteira Sorter BHT (plano CLOSED/FRACTION + envio WCS). #MT-2D61607">
					<input id="sorter_mode" type="checkbox" class="dib">&nbsp;SORTER
				</label>
			</div>
			<div class="mtm">
				<button class='bn_Escape button'>Cancelar</button>
				<button class='bn_Enter button'>Gerar <span id="count"></span> saídas</button>
			</div>
		</form>
	`,

	form:
	{
		selector: '#create-outputs',
		init(formset)
		{
			formset.form.eraseValues();
			formset.loadList('#companies', 'companies', { labels: ['nick'] });
			const root = document.querySelector('#create-outputs');
			const sorter = root?.querySelector('#sorter_mode');
			const reserve = root?.querySelector('#reserve_flag');
			if (sorter && reserve)
			{
				sorter.addEventListener('change', () =>
				{
					if (sorter.checked)
						reserve.checked = true;
				});
				reserve.addEventListener('change', () =>
				{
					if (!reserve.checked)
						sorter.checked = false;
				});
			}
			Object.getPrototypeOf(this).init.call(this);
		},
	},
	
	fields: [
		{ properties: { selector: '#company_id' }, types: [types.pubsub(), types.datalist()] },
		{
			properties: { selector: '#warehouse_id' },
			types: [
				types.pubsub(),
				types.observer('company_id'),
				obs_load_warehouses_create_outputs(),
			],
		},
		{ properties: { selector: '#include_expired' }, types: [types.checkbox()] },
		{ properties: { selector: '#reserve_flag' }, types: [types.checkbox()] },
		{ properties: { selector: '#sorter_mode' }, types: [types.checkbox()] },
	]

};
